/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationUserModel
 */
export interface FrontApplicationUserModel {
    /**
     * Mail
     * @type {string}
     * @memberof FrontApplicationUserModel
     */
    email: string;
    /**
     * Facebook id
     * @type {string}
     * @memberof FrontApplicationUserModel
     */
    facebookId: string;
    /**
     * Google id
     * @type {string}
     * @memberof FrontApplicationUserModel
     */
    googleId: string;
    /**
     * Apple id
     * @type {string}
     * @memberof FrontApplicationUserModel
     */
    appleId: string;
    /**
     * ID rádií
     * @type {Array<number>}
     * @memberof FrontApplicationUserModel
     */
    favourites: Array<number>;
    /**
     * Apple id
     * @type {number}
     * @memberof FrontApplicationUserModel
     */
    id: number;
    /**
     * Souhlas s gdpr
     * @type {boolean}
     * @memberof FrontApplicationUserModel
     */
    gdpr: boolean;
}

/**
 * Check if a given object implements the FrontApplicationUserModel interface.
 */
export function instanceOfFrontApplicationUserModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "facebookId" in value;
    isInstance = isInstance && "googleId" in value;
    isInstance = isInstance && "appleId" in value;
    isInstance = isInstance && "favourites" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "gdpr" in value;

    return isInstance;
}

export function FrontApplicationUserModelFromJSON(json: any): FrontApplicationUserModel {
    return FrontApplicationUserModelFromJSONTyped(json, false);
}

export function FrontApplicationUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationUserModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'facebookId': json['facebook_id'],
        'googleId': json['google_id'],
        'appleId': json['apple_id'],
        'favourites': json['favourites'],
        'id': json['id'],
        'gdpr': json['gdpr'],
    };
}

export function FrontApplicationUserModelToJSON(value?: FrontApplicationUserModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'facebook_id': value.facebookId,
        'google_id': value.googleId,
        'apple_id': value.appleId,
        'favourites': value.favourites,
        'id': value.id,
        'gdpr': value.gdpr,
    };
}

